// Constant: Content > Experience contract types
const EXPERIENCE_CONTRACT_TYPES = ['employment', 'consultancy', 'independent']

// Constant: Content > Featured works
const FEATURED_WORKS = ['graphjs', 'graphjs-website', 'socradar-branding', 'base64-ai-branding', 'favogue', 'cardz', 'piccture', 'brush']

// Constant: Content > Full featured works
const FULL_FEATURED_WORKS = [...FEATURED_WORKS, 'fihrist', 'groups']

// Constant: Content > Work categories
const WORK_CATEGORIES = ['Featured', 'UI/UX/IxD', 'Branding', 'Graphic Design', 'Social Media', 'Corporate Identity', 'Collections']

// Constant: Content > Work cover types
const WORK_COVER_TYPES = ['Branding', 'Collection', 'Corporate Identity', 'Graphic Design', 'Mobile Application', 'Responsive Website', 'Social Media', 'Website']

// Export
export {
  EXPERIENCE_CONTRACT_TYPES,
  FEATURED_WORKS,
  FULL_FEATURED_WORKS,
  WORK_CATEGORIES,
  WORK_COVER_TYPES
}
